/**
 * =========================================================================================
 * Component - Button
 * =========================================================================================
 **/

import React, { useMemo } from 'react';
import { isMobileDevice } from "../common/function";
import * as Icon from 'ubs-icons';
import PropTypes from "prop-types";
import { COLOR } from '../common/constant';

const UButton = (props) => {
    const isMobileView = useMemo(() => {
        return isMobileDevice() || window.innerWidth <= 768
    }, [])

    const shouldAddMobileClass = useMemo(() => {
        const mobileClassTypes = ['discard', 'cancel', 'delete', 'save', 'update', 'approve', 'submit', 'reject', 'copy', 'edit', 'search', 'back', 'next', 'download', 'send', 'preview', 'share'];
        return isMobileView && mobileClassTypes.includes(props?.type);
    }, [isMobileView, props?.type]);

    const classNames = useMemo(() => {
        let classes = 'u_btn';

        if (props?.cn) classes += ` ${props?.cn}`;
        if (props?.variant) classes += ` ${props?.variant}`;
        if (props?.mobile) classes += ` u_btn-mobile`;
        if (props?.loading) classes += ` loading`;
        if (!props?.large) classes += ` small`;

        /** copied from HRMS */
        if (props?.cn) classes += ` ${props?.cn}`;
        if (props?.variant) classes += ` u_btn__${props?.variant}`;
        if (shouldAddMobileClass && props?.fullButton) {
            classes += ` `;
        } else if (shouldAddMobileClass) classes += ` u_btn-mobile`;
        if (props?.loading) classes += ` u_btn__loading`;
        return classes;
    }, [props?.cn, props?.variant, props?.loading, shouldAddMobileClass]);

    const icon = useMemo(() => {
        if (['discard', 'cancel', 'delete'].includes(props?.type?.toLowerCase())) return <Icon.Close fill={COLOR.u_font} size={12} />;
        else if (['save', 'update', 'approve', 'submit'].includes(props?.type?.toLowerCase())) return <Icon.CheckMark fill={COLOR.u_white} size={14} />;
        else if (['reject'].includes(props?.type?.toLowerCase())) return <Icon.Close fill={COLOR.u_white} size={12} />;
        else if (['copy'].includes(props?.type?.toLowerCase())) return <Icon.Copy fill={COLOR.u_white} size={12} />;
        else if (['edit'].includes(props?.type?.toLowerCase())) return <Icon.Edit fill={COLOR.u_white} size={16} />;
        else if (['search'].includes(props?.type?.toLowerCase())) return <Icon.Search fill={COLOR.u_white} size={16} />;
        else if (['back'].includes(props?.type?.toLowerCase())) return <Icon.LeftArrow fill={COLOR.u_font} size={16} />;
        else if (['next'].includes(props?.type?.toLowerCase())) return <Icon.RightArrow fill={COLOR.u_white} size={16} />;
        else if (['download'].includes(props?.type?.toLowerCase())) return <Icon.Download fill={COLOR.u_white} size={16} />;
        else if (['send'].includes(props?.type?.toLowerCase())) return <Icon.SendMessage fill={COLOR.u_white} size={16} />;
        else if (['copy'].includes(props?.type?.toLowerCase())) return <Icon.Copy fill={COLOR.u_white} size={16} />;
        else if (['save draft'].includes(props?.type?.toLowerCase())) return <Icon.Info fill={COLOR.u_blue} size={16} />;
        else if (['connect'].includes(props?.type?.toLowerCase())) return <Icon.Link fill={COLOR.u_blue} size={16} />;
        else if (['connected'].includes(props?.type?.toLowerCase())) return <Icon.Link fill={COLOR.u_white} size={16} />;
        else return props?.type;
    }, [props?.type])

    return (
        <React.Fragment>
            <button type={props?.btnType} className={classNames} disabled={props?.disabled} onClick={props?.onClick} style={props?.style}>
                {isMobileView && props?.fullButton ? props?.type : isMobileView ? icon : props?.type}
                {props?.loading && <span className="u_btn__loader" />}
            </button>
        </React.Fragment>
    );
};

UButton.propTypes = {
    cn: PropTypes.string,
    variant: PropTypes.string,
    type: PropTypes.string,
    btnType: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    mobile: PropTypes.any,
    onClick: PropTypes.func,
}
UButton.defaultProps = {
    cn: '',
    variant: 'blue',
    type: '',
    btnType: 'button',
    loading: false,
    disabled: false,
    onClick: () => {
    },
}
export default UButton;